import {useEffect, useRef} from "react";
import * as reviewService from "../service/reviewService";

// 리뷰 리스트 조회
export function useReviewList(setters, data) {
  const previousDataRef = useRef();

  useEffect(() => {
    const response = async () => {
      if(data) {
        const getData = await reviewService.getReviewList(data);

        setters.setReviewList?.(getData.data);
        setters.setTotalPage?.(getData.totalPage);
        setters.setTotalCount?.(getData.totalCount);
        setters.setShopReplyCount?.(getData.shopReplyCount);
        setters.setEvaluationCountList?.(getData.evaluationCountList);
      }
    }

    if (JSON.stringify(previousDataRef.current) !== JSON.stringify(data)) {
      response();
      previousDataRef.current = data;
    }
  }, [data])
}